import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITileSection from 'UIComponents/tile/UITileSection';
import UILink from 'UIComponents/link/UILink';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIFlex from 'UIComponents/layout/UIFlex';
import Small from 'UIComponents/elements/Small';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ConnectAppButton from './ConnectAppButton';
import isEmbedded from '../utils/isEmbedded';
import { isOnlyRequestingOAuthScope } from '../utils/urls';
import { getHasIntegrationsManagementWrite } from '../selectors/ScopeSelectors';
import { getEcosystemDetailsData } from '../selectors/EcosystemSelectors';
import { getIsRequestingNewScopes } from '../selectors/AppSelectors';
import Tracker from '../utils/usageTracker';
import { EVENTS } from '../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AuthorizeFooter() {
  const location = useLocation();
  const hasIntegrationsManagementWrite = useSelector(getHasIntegrationsManagementWrite);
  const isRequestingNewScopes = useSelector(getIsRequestingNewScopes);
  const hasNoInstallPermission = !hasIntegrationsManagementWrite && !isOnlyRequestingOAuthScope(location.search) && isRequestingNewScopes;
  const [termsConfirmed, setTermsConfirmed] = useState(false);
  const ecosystemDetails = useSelector(getEcosystemDetailsData);

  // Only disable the term checkbox if:
  // There are ecosystemDetails and the following conditions are met:
  // they do not have the integrations-management-write and the app has not been installed before and the app is requesting more than just the oauth scope
  const termsDisabled = !!(ecosystemDetails && (hasIntegrationsManagementWrite || isOnlyRequestingOAuthScope(location.search) || !isRequestingNewScopes));
  return /*#__PURE__*/_jsx(UITileSection, {
    children: /*#__PURE__*/_jsxs("div", {
      children: [ecosystemDetails && /*#__PURE__*/_jsxs(UIFlex, {
        className: "m-bottom-4",
        children: [/*#__PURE__*/_jsx(UITooltip, {
          disabled: termsDisabled,
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "oauth.app.marketplaceAccess.toContinueNeedPermissionTooltip"
          }),
          children: /*#__PURE__*/_jsx(UICheckbox, {
            className: "m-bottom-4",
            alignment: "center",
            onChange: ({
              target: {
                checked
              }
            }) => setTermsConfirmed(checked),
            disabled: !termsDisabled
          })
        }), /*#__PURE__*/_jsx(Small, {
          className: "m-left-2",
          children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "oauth.app.termsAndPrivacy.body_jsx",
            elements: {
              Link: UILink
            },
            options: {
              privacyPolicyProps: {
                href: ecosystemDetails.privacyUrl,
                external: true
              },
              termLinkProps: {
                href: ecosystemDetails.termsUrl,
                external: true
              }
            }
          })
        })]
      }), /*#__PURE__*/_jsx(ConnectAppButton, {
        hasUnconfirmedTerms: !!ecosystemDetails && !termsConfirmed,
        hasNoInstallPermission: hasNoInstallPermission
      }), !isEmbedded && /*#__PURE__*/_jsx(UIButton, {
        className: "m-left-5",
        href: "https://hubspot.com",
        onClick: () => {
          Tracker.track(EVENTS.INSTALL_FLOW_CANCELED);
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "oauth.authorization.cancel"
        })
      })]
    })
  });
}
export default AuthorizeFooter;